<div class="td-wb-fixed-messages">

  @if (!isMessages()) {
    <td-wb-empty>
      <td-wb-icon tdWbEmptyIcon
                  iconId="email"
                  size="64" />
      <td-wb-empty-header translate="tdWb.messages.NO_MESSAGES" />
    </td-wb-empty>
  }

  <ul class="td-wb-fixed-messages__list">
    @for (message of messages; track message) {
      <li
        [ngClass]="getMessageClass(message)">
        <button class="td-wb-fixed-messages__item__toggle"
                tdWbButton
                tdWbButtonType="icon"
                [attr.aria-expanded]="message.expanded"
                (click)="toggle(message)">
          <!-- Icon -->
          <div class="td-wb-fixed-messages__item__icon">
            <td-wb-expand-icon [expanded]="message.expanded" />
          </div>
          <!-- Content -->
          <div class="td-wb-fixed-messages__item__content">
            <!-- Date -->
            @if (message.effectiveDate) {
              <div class="td-wb-fixed-messages__item__date"
                   [innerText]="message.effectiveDate | tdWbDate">
              </div>
            }
            <!-- Subject -->
            <div class="td-wb-fixed-messages__item__subject"
                 [innerHtml]="message.subject"></div>
            <!-- Teaser -->
            <div class="td-wb-fixed-messages__item__teaser"
                 [innerHtml]="message.teaser"></div>
          </div>
        </button>
        <!-- Message body -->
        @if (message.expanded) {
          <td-wb-messages-body class="td-wb-fixed-messages__item__body"
                               [content]="message.body"
                               [@slideInOutAnimation] />
        }
      </li>
    }
  </ul>
</div>
